import { Button } from "@/components/ui/button";
import { cn } from "@/utils";
import { AtSign, ExternalLink } from "lucide-react";
import React from "react";

interface CompactListItemProps {
  icon: React.ReactNode;
  title: string;
  subtitle?: string;
  webLink?: string;
  onClick: () => void;
  onAddToContext: () => void;
  className?: string;
}

export const CompactListItem: React.FC<CompactListItemProps> = ({
  icon,
  title,
  subtitle,
  webLink,
  onClick,
  onAddToContext,
  className,
}) => {
  return (
    <div
      className={cn(
        "group w-full flex items-start gap-3 p-3 hover:bg-accent/50 cursor-pointer border-b transition-colors",
        className,
      )}
      onClick={(e) => {
        // Stop propagation so the click doesn't bubble to any EntityDragRow
        // wrapper — GitHub rows use click to navigate, not to add to canvas.
        e.stopPropagation();
        onClick();
      }}
    >
      <div className="h-10 w-10 shrink-0 flex items-center justify-center bg-muted rounded-full">
        {icon}
      </div>
      <div className="flex-1 min-w-0 overflow-hidden">
        <div className="flex items-center gap-2 mb-1">
          <span className="flex-1 font-semibold truncate">{title}</span>
          <div className="flex items-center gap-1 shrink-0 opacity-0 group-hover:opacity-100 transition-opacity">
            {webLink && (
              <Button
                variant="ghost"
                size="icon"
                className="h-6 w-6"
                onClick={(e) => {
                  e.stopPropagation();
                  window.open(webLink, "_blank");
                }}
                aria-label="Open in GitHub"
              >
                <ExternalLink className="h-4 w-4" />
              </Button>
            )}
            <Button
              variant="ghost"
              size="icon"
              className="h-6 w-6"
              onClick={(e) => {
                e.stopPropagation();
                onAddToContext();
              }}
              aria-label="Add to context"
            >
              <AtSign className="h-4 w-4" />
            </Button>
          </div>
        </div>
        {subtitle && (
          <div className="text-sm text-muted-foreground line-clamp-1">
            {subtitle}
          </div>
        )}
      </div>
    </div>
  );
};
